export function action(type, payload) {
    if (payload) {
        return {
            type,
            payload,
        };
    }
    return { type };
}
